{
  "PROFILE_SETTINGS": {
    "LINK": "Cài Đặt Hồ Sơ",
    "TITLE": "Cài Đặt Hồ Sơ",
    "BTN_TEXT": "Cập Nhật Hồ Sơ",
    "DELETE_AVATAR": "Xoá hình đại diện",
    "AVATAR_DELETE_SUCCESS": "Ảnh đại diện đã được xoá thành công",
    "AVATAR_DELETE_FAILED": "Đã xảy ra lỗi khi xoá ảnh đại diện, vui lòng thử lại",
    "UPDATE_SUCCESS": "Hồ sơ của bạn đã được cập nhật thành công",
    "PASSWORD_UPDATE_SUCCESS": "Mật khẩu của bạn đã được thay đổi thành công",
    "AFTER_EMAIL_CHANGED": "Hồ sơ của bạn đã được cập nhật thành công, vui lòng đăng nhập lại khi thông tin đăng nhập của bạn được thay đổi",
    "FORM": {
      "PICTURE": "Ảnh hồ sơ",
      "EMAIL_SIGNATURE_PICTURE": {
        "LABEL": "Hình ảnh chữ ký email",
        "HINT": "Được sử dụng trong chữ ký email. {'{{'}email_signature_picture{'}}'} được thay thế bằng URL của hình ảnh này (không phải thẻ img) — hãy dùng nó làm nguồn hình ảnh (thuộc tính src của thẻ img) trong chữ ký của bạn hoặc chữ ký hộp thư đến. Nếu không được đặt, sẽ không có gì được chèn vào.",
        "DELETE_SUCCESS": "Hình ảnh chữ ký email đã được xóa thành công",
        "DELETE_FAILED": "Đã xảy ra lỗi khi xóa hình ảnh chữ ký email, vui lòng thử lại"
      },
      "AVATAR": "Hình ảnh hồ sơ cá nhân",
      "ERROR": "Vui lòng sửa lỗi biểu mẫu",
      "REMOVE_IMAGE": "Xoá",
      "UPLOAD_IMAGE": "Tải lên hình ảnh",
      "UPDATE_IMAGE": "Cập nhật hình ảnh",
      "PROFILE_SECTION": {
        "TITLE": "Hồ sơ cá nhân",
        "NOTE": "Địa chỉ email của bạn là danh tính của bạn và được sử dụng để đăng nhập."
      },
      "SEND_MESSAGE": {
        "TITLE": "Phím nóng để gửi tin nhắn",
        "NOTE": "Bạn có thể chọn một phím nóng (Enter hoặc Cmd/Ctrl+Enter) dựa trên sở thích viết của bạn.",
        "UPDATE_SUCCESS": "Cài đặt của bạn đã được cập nhật thành công",
        "CARD": {
          "ENTER_KEY": {
            "HEADING": "Enter (↵)",
            "CONTENT": "Gửi tin nhắn bằng cách nhấn phím Enter thay vì nhấp vào nút gửi."
          },
          "CMD_ENTER_KEY": {
            "HEADING": "Cmd/Ctrl + Enter (⌘ + ↵)",
            "CONTENT": "Gửi tin nhắn bằng cách nhấn phím Cmd/Ctrl + enter thay vì nhấp vào nút gửi."
          }
        }
      },
      "INTERFACE_SECTION": {
        "TITLE": "Interface",
        "NOTE": "Tùy chỉnh giao diện bảng điều khiển của bạn.",
        "FONT_SIZE": {
          "TITLE": "Font size",
          "NOTE": "Adjust the text size across the dashboard based on your preference.",
          "UPDATE_SUCCESS": "Your font settings have been updated successfully",
          "UPDATE_ERROR": "There is an error while updating the font settings, please try again",
          "OPTIONS": {
            "SMALLER": "Smaller",
            "SMALL": "Small",
            "DEFAULT": "Mặc định",
            "LARGE": "Large",
            "LARGER": "Larger",
            "EXTRA_LARGE": "Extra Large"
          }
        },
        "UI_LANGUAGE": {
          "TITLE": "Ngôn ngữ bảng điều khiển",
          "NOTE": "Ghi đè ngôn ngữ tài khoản cho bảng điều khiển của riêng bạn. Để trống để dùng ngôn ngữ mặc định của tài khoản.",
          "USE_ACCOUNT_DEFAULT": "Dùng mặc định của tài khoản",
          "API_SUCCESS": "Ngôn ngữ bảng điều khiển của bạn đã được cập nhật thành công"
        },
        "MESSAGE_TRANSLATION": {
          "TITLE": "Ngôn ngữ tin nhắn",
          "NOTE": "Chọn hiển thị tin nhắn gốc hay bản dịch của chúng",
          "ORIGINAL": "Bản gốc",
          "TRANSLATED": "Đã dịch"
        },
        "PASTE_BEHAVIOR": {
          "TITLE": "Cách xử lý khi dán",
          "NOTE": "Chọn cách xử lý nội dung được dán khi soạn tin nhắn",
          "UPDATE_SUCCESS": "Cài đặt dán của bạn đã được cập nhật thành công",
          "OPTIONS": {
            "PRESERVE_ALL": {
              "HEADING": "Giữ nguyên toàn bộ định dạng",
              "DESCRIPTION": "Giữ nguyên toàn bộ định dạng, gồm cả bảng, kiểu chữ và các phần tử HTML khác, khi dán nội dung."
            },
            "TEXT_WITH_LINKS": {
              "HEADING": "Chỉ văn bản kèm liên kết",
              "DESCRIPTION": "Chuyển thành văn bản thuần nhưng vẫn giữ các liên kết có thể nhấp khi dán nội dung."
            },
            "PLAIN_TEXT_ONLY": {
              "HEADING": "Chỉ văn bản thuần",
              "DESCRIPTION": "Xóa toàn bộ định dạng và chuyển thành văn bản thuần khi dán nội dung."
            }
          }
        },
        "REPLY_BOX_HEIGHT": {
          "TITLE": "Chiều cao hộp trả lời",
          "NOTE": "Đặt chiều cao tối thiểu của hộp trả lời theo phần trăm chiều cao màn hình. Chỉ áp dụng cho các cuộc trò chuyện qua email.",
          "UPDATE_SUCCESS": "Cài đặt chiều cao hộp trả lời của bạn đã được cập nhật thành công",
          "PERCENT_LABEL": "Chiều cao (% chiều cao màn hình)",
          "OPTIONS": {
            "DEFAULT": {
              "HEADING": "Mặc định",
              "DESCRIPTION": "Hộp trả lời bắt đầu nhỏ và lớn dần khi bạn nhập."
            },
            "CUSTOM": {
              "HEADING": "Tùy chỉnh",
              "DESCRIPTION": "Hộp trả lời luôn có chiều cao tối thiểu bằng phần trăm đã chọn của chiều cao màn hình."
            }
          }
        }
      },
      "AUTO_NAVIGATION": {
        "TITLE": "Tự động chuyển đến cuộc trò chuyện tiếp theo",
        "NOTE": "Tự động chuyển sang cuộc trò chuyện đang mở tiếp theo sau khi giải quyết cuộc trò chuyện hiện tại",
        "UPDATE_SUCCESS": "Cài đặt tự động chuyển đã được cập nhật thành công"
      },
      "MESSAGE_SIGNATURE_SECTION": {
        "TITLE": "Chữ ký tin nhắn cá nhân",
        "DESCRIPTION": "Tạo một chữ ký tin nhắn riêng để hiển thị ở cuối mỗi email bạn gửi. Bạn cũng có thể thêm một hình ảnh nội tuyến.",
        "NOTE": "Create a unique message signature to appear at the end of every message you send from any inbox. You can also include an inline image, which is supported in live-chat, email, and API inboxes.",
        "BTN_TEXT": "Lưu chữ ký tin nhắn",
        "API_ERROR": "Không thể lưu chữ ký! Thử lại",
        "API_SUCCESS": "Chữ ký được lưu thành công",
        "IMAGE_UPLOAD_ERROR": "Couldn't upload image! Try again",
        "IMAGE_UPLOAD_SUCCESS": "Image added successfully. Please click on save to save the signature",
        "IMAGE_UPLOAD_SIZE_ERROR": "Kích thước ảnh phải nhỏ hơn {size}MB"
      },
      "MESSAGE_SIGNATURE": {
        "LABEL": "Chữ ký tin nhắn",
        "ERROR": "Chữ ký tin nhắn không được rỗng",
        "PLACEHOLDER": "Thêm chữ ký tin nhắn cá nhân của bạn ở đây."
      },
      "PASSWORD_SECTION": {
        "TITLE": "Mật khẩu",
        "NOTE": "Cập nhật mật khẩu của bạn sẽ đặt lại thông tin đăng nhập của bạn trên nhiều thiết bị.",
        "BTN_TEXT": "Thay đổi mật khẩu"
      },
      "ACCESS_TOKEN": {
        "TITLE": "Token truy cập",
        "NOTE": "Có thể sử dụng Token này nếu bạn đang xây dựng tích hợp dựa trên API",
        "COPY": "Sao Chép",
        "REGENERATE": "Tạo lại",
        "REGENERATE_SUCCESS": "Token truy cập đã được tạo lại thành công. Vui lòng cập nhật các tích hợp đang sử dụng token cũ.",
        "REGENERATE_CONFIRM_TITLE": "Tạo lại token truy cập?",
        "REGENERATE_CONFIRM_MESSAGE": "Thao tác này sẽ vô hiệu hóa token hiện tại. Các tích hợp đang sử dụng token cũ sẽ ngừng hoạt động."
      },
      "CHROME_EXTENSION": {
        "TITLE": "Tiện ích mở rộng Chrome",
        "NOTE": "Cài đặt tiện ích mở rộng Chrome của chúng tôi để nhận thông báo chi tiết về cuộc gọi đến.",
        "INSTALL_BUTTON": "Cài đặt tiện ích mở rộng",
        "ALREADY_INSTALLED": "Đã cài đặt tiện ích mở rộng"
      },
      "AUDIO_NOTIFICATIONS_SECTION": {
        "TITLE": "Audio Alerts",
        "NOTE": "Enable audio alerts in dashboard for new messages and conversations.",
        "PLAY": "Play sound",
        "ALERT_TYPES": {
          "NONE": "Không có",
          "MINE": "Assigned",
          "ALL": "Tất cả",
          "ASSIGNED": "My assigned conversations",
          "UNASSIGNED": "Unassigned conversations",
          "NOTME": "Open conversations assigned to others"
        },
        "ALERT_COMBINATIONS": {
          "NONE": "You haven't selected any options, you won't receive any audio alerts.",
          "ASSIGNED": "You'll receive alerts for conversations assigned to you.",
          "UNASSIGNED": "You'll receive alerts for any unassigned conversations.",
          "NOTME": "You'll receive alerts for conversations assigned to others.",
          "ASSIGNED+UNASSIGNED": "You'll receive alerts for your assigned conversations and any unattended ones.",
          "ASSIGNED+NOTME": "You'll receive alerts for conversations assigned to you and to others, but not for unassigned ones.",
          "NOTME+UNASSIGNED": "You'll receive alerts for unattended conversations and those assigned to others.",
          "ASSIGNED+NOTME+UNASSIGNED": "You'll receive alerts for all conversations."
        },
        "ALERT_TYPE": {
          "TITLE": "Alert events for conversations",
          "NONE": "Không có",
          "ASSIGNED": "Cuộc trò chuyện được phân công",
          "ALL_CONVERSATIONS": "Tất cả cuộc trò chuyện"
        },
        "DEFAULT_TONE": {
          "TITLE": "Âm báo:"
        },
        "CONDITIONS": {
          "TITLE": "Điều kiện cảnh báo:",
          "CONDITION_ONE": "Chỉ gửi cảnh báo âm thanh nếu cửa sổ trình duyệt không hoạt động",
          "CONDITION_TWO": "Gửi thông báo cứ sau 30 giây cho đến khi tất cả các cuộc hội thoại được chỉ định được đọc"
        },
        "SOUND_PERMISSION_ERROR": "Autoplay is disabled in your browser. To hear alerts automatically, enable sound permission in your browser settings or interact with the page.",
        "READ_MORE": "Xem thêm"
      },
      "EMAIL_NOTIFICATIONS_SECTION": {
        "TITLE": "Thông Báo Email",
        "NOTE": "Cập nhật tùy chọn thông báo qua email của bạn tại đây",
        "CONVERSATION_ASSIGNMENT": "Gửi thông báo qua email khi cuộc trò chuyện được chỉ định cho tôi",
        "CONVERSATION_CREATION": "Gửi thông báo qua email khi cuộc trò chuyện mới được tạo",
        "CONVERSATION_MENTION": "Gửi thông báo email khi bạn được nhắc đến trong 1 cuộc trò chuyện",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Gửi thông báo email khi có một tin nhắn mới được tạo trong cuộc trò chuyện được phân công",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Send email notifications when a new message is created in a participating conversation",
        "SLA_MISSED_FIRST_RESPONSE": "Send email notifications when a conversation misses first response SLA",
        "SLA_MISSED_NEXT_RESPONSE": "Send email notifications when a conversation misses next response SLA",
        "SLA_MISSED_RESOLUTION": "Send email notifications when a conversation misses resolution SLA"
      },
      "NOTIFICATIONS": {
        "TITLE": "Notification preferences",
        "TYPE_TITLE": "Notification type",
        "EMAIL": "Email",
        "PUSH": "Push notification",
        "TYPES": {
          "CONVERSATION_CREATED": "A new conversation is created",
          "CONVERSATION_ASSIGNED": "A conversation is assigned to you",
          "CONVERSATION_MENTION": "You are mentioned in a conversation",
          "ASSIGNED_CONVERSATION_NEW_MESSAGE": "A new message is created in an assigned conversation",
          "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "A new message is created in a participating conversation",
          "UNASSIGNED_CONVERSATION_NEW_MESSAGE": "Một tin nhắn mới được tạo trong cuộc trò chuyện không có nhân viên khả dụng",
          "SLA_MISSED_FIRST_RESPONSE": "A conversation misses first response SLA",
          "SLA_MISSED_NEXT_RESPONSE": "A conversation misses next response SLA",
          "SLA_MISSED_RESOLUTION": "A conversation misses resolution SLA"
        },
        "BROWSER_PERMISSION": "Enable push notifications for your browser so you’re able to receive them",
        "ALLOW_NOTIFICATION_DURING_CALL": "Cho phép thông báo đẩy khi bạn đang trong cuộc gọi",
        "TEST_PUSH": "Kiểm tra",
        "TESTING": "Đang kiểm tra...",
        "TEST_PUSH_DESCRIPTION": "Gửi thông báo kiểm tra để xác minh thiết lập của bạn",
        "TEST_NOTIFICATION_ERROR": "Không thể gửi thông báo kiểm tra. Vui lòng thử lại.",
        "TEST_LOCAL_TITLE": "Thông báo kiểm tra (Cục bộ)",
        "TEST_LOCAL_BODY": "Đây là thông báo trình duyệt cục bộ. Nếu bạn thấy thông báo này, thông báo trình duyệt đang hoạt động!"
      },
      "API": {
        "UPDATE_SUCCESS": "Tùy chọn thông báo của bạn đã được cập nhật thành công",
        "UPDATE_ERROR": "Đã xảy ra lỗi khi cập nhật tùy chọn, vui lòng thử lại"
      },
      "PUSH_NOTIFICATIONS_SECTION": {
        "TITLE": "Thông Báo",
        "NOTE": "Cập nhật tùy chọn thông báo của bạn tại đây",
        "CONVERSATION_ASSIGNMENT": "Gửi thông báo khi cuộc trò chuyện được chỉ định cho tôi",
        "CONVERSATION_CREATION": "Gửi thông báo khi cuộc trò chuyện mới được tạo",
        "CONVERSATION_MENTION": "Gửi thông báo đẩy khi bạn được nhắc đến trong 1 cuộc trò chuyện",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Gửi thông báo đẩy khi có một tin nhắn mới được tạo trong cuộc trò chuyện được phân công",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Send push notifications when a new message is created in a participating conversation",
        "HAS_ENABLED_PUSH": "Bạn đã bật tính năng thông báo cho trình duyệt này.",
        "REQUEST_PUSH": "Bật thông báo",
        "SLA_MISSED_FIRST_RESPONSE": "Send push notifications when a conversation misses first response SLA",
        "SLA_MISSED_NEXT_RESPONSE": "Send push notifications when a conversation misses next response SLA",
        "SLA_MISSED_RESOLUTION": "Send push notifications when a conversation misses resolution SLA"
      },
      "PROFILE_IMAGE": {
        "LABEL": "Hình ảnh hồ sơ cá nhân"
      },
      "NAME": {
        "LABEL": "Tên đầy đủ của bạn",
        "ERROR": "Vui lòng nhập tên đầy đủ hợp lệ",
        "PLACEHOLDER": "Vui lòng nhập tên đầy đủ của bạn"
      },
      "DISPLAY_NAME": {
        "LABEL": "Tên hiển thị",
        "ERROR": "Vui lòng nhập tên hiển thị hợp lệ",
        "PLACEHOLDER": "Vui lòng nhập tên hiển thị, tên này sẽ được hiển thị trong các cuộc trò chuyện"
      },
      "POSITION": {
        "LABEL": "Chức vụ",
        "ERROR": "Vui lòng nhập chức vụ hợp lệ",
        "PLACEHOLDER": "Vui lòng nhập chức vụ của bạn"
      },
      "CUSTOM_LINE": {
        "LABEL": "Dòng tùy chỉnh",
        "ERROR": "Vui lòng nhập dòng tùy chỉnh hợp lệ",
        "PLACEHOLDER": "Vui lòng nhập dòng tùy chỉnh của bạn"
      },
      "AVAILABILITY": {
        "LABEL": "Khả dụng",
        "STATUS": {
          "ONLINE": "Trực Tuyến",
          "BUSY": "Bận",
          "OFFLINE": "Không Trực Tuyến"
        },
        "SET_AVAILABILITY_SUCCESS": "Tính khả dụng đã được thiết lập thành công",
        "SET_AVAILABILITY_ERROR": "Không thể đặt, vui lòng thử lại"
      },
      "EMAIL_PREVIEW_FORMAT": {
        "TITLE": "Định dạng xem trước email trong danh sách cuộc trò chuyện",
        "NOTE": "Chọn nội dung hiển thị trong danh sách cuộc trò chuyện đối với các cuộc trò chuyện từ hộp thư email",
        "SUBJECT": "Chủ đề",
        "SUBJECT_WITH_NOTE": "Chủ đề và tin nhắn cuối cùng nếu đó là ghi chú nội bộ",
        "UPDATE_SUCCESS": "Cài đặt xem trước email đã được cập nhật thành công"
      },
      "DISABLE_SHORTCUTS": {
        "TITLE": "Tắt phím tắt",
        "NOTE": "Tắt tất cả phím tắt trong toàn bộ ứng dụng",
        "UPDATE_SUCCESS": "Cài đặt phím tắt đã được cập nhật thành công"
      },
      "FOLDER_ORDER": {
        "TITLE": "Thứ tự thư mục",
        "NOTE": "Tùy chỉnh thứ tự các thư mục (chế độ xem tùy chỉnh) xuất hiện trong thanh bên. Kéo và thả để sắp xếp lại.",
        "NO_FOLDERS": "Không tìm thấy thư mục tùy chỉnh nào. Hãy tạo thư mục để sắp xếp các cuộc trò chuyện của bạn."
      },
      "SIDEBAR_CONFIGURATION": {
        "TITLE": "Cấu hình thanh bên",
        "NOTE": "Tùy chỉnh những phần hiển thị trong thanh bên cuộc trò chuyện.",
        "SAVE_BUTTON": "Lưu cấu hình",
        "UPDATE_SUCCESS": "Cấu hình thanh bên đã được cập nhật thành công",
        "UPDATE_ERROR": "Đã xảy ra lỗi khi cập nhật cấu hình thanh bên, vui lòng thử lại",
        "OPTIONS": {
          "ALL_CONVERSATIONS": "Tất cả cuộc trò chuyện",
          "ALL_CONVERSATIONS_DESC": "Hiển thị mục menu Tất cả cuộc trò chuyện trong thanh bên",
          "INBOX": "Hộp thư đến",
          "INBOX_DESC": "Hiển thị hộp thư đến chính có thông báo chưa đọc",
          "CONVERSATION_GROUPS": "Nhắn đến và Không giám sát",
          "CONVERSATION_GROUPS_DESC": "Hiển thị các nhóm cuộc trò chuyện Nhắn đến và Không giám sát",
          "FOLDERS": "Thư mục",
          "FOLDERS_DESC": "Hiển thị các chế độ xem tùy chỉnh (thư mục) cho cuộc trò chuyện đã sắp xếp",
          "TEAMS": "Nhóm",
          "TEAMS_DESC": "Hiển thị các cuộc trò chuyện được lọc theo phân công nhóm",
          "CHANNELS": "Hộp thư đến",
          "CHANNELS_DESC": "Hiển thị các cuộc trò chuyện được lọc theo hộp thư đến",
          "LABELS": "Nhãn",
          "LABELS_DESC": "Hiển thị các cuộc trò chuyện được lọc theo nhãn"
        }
      },
      "PHONE_SETTINGS": {
        "TITLE": "Cài đặt điện thoại",
        "NOTE": "Nhập thông tin đăng nhập vào hệ thống PBX của bạn.",
        "USERNAME": "Tên người dùng",
        "PASSWORD": "Mật khẩu",
        "SUBMIT": "Lưu",
        "USERNAME_INVALID": "Tên người dùng chỉ được chứa chữ cái, chữ số và . _ - + — không được có khoảng trắng hoặc địa chỉ email.",
        "API": {
          "USERNAME_INVALID": "Tên người dùng không phải là tên người dùng SIP hợp lệ. Chỉ dùng chữ cái, chữ số và . _ - + — không dùng khoảng trắng hoặc địa chỉ email.",
          "USERNAME_TAKEN": "Tên người dùng này đã được một nhân viên khác trong tài khoản này sử dụng."
        }
      },
      "EMAIL": {
        "LABEL": "Địa chỉ email của bạn",
        "ERROR": "Vui lòng nhập một địa chỉ email hợp lệ",
        "PLACEHOLDER": "Vui lòng nhập địa chỉ email của bạn, địa chỉ này sẽ được hiển thị trong các cuộc trò chuyện"
      },
      "CURRENT_PASSWORD": {
        "LABEL": "Mật khẩu hiện tại",
        "ERROR": "Vui lòng nhập mật khẩu hiện tại",
        "PLACEHOLDER": "Vui lòng nhập mật khẩu hiện tại"
      },
      "PASSWORD": {
        "LABEL": "Mật khẩu mới",
        "ERROR": "Vui lòng nhập mật khẩu có độ dài từ 6 trở lên",
        "PLACEHOLDER": "Vui lòng nhập mật khẩu mới"
      },
      "PASSWORD_CONFIRMATION": {
        "LABEL": "Xác nhận mật khẩu mới",
        "ERROR": "Xác nhận mật khẩu phải khớp với mật khẩu",
        "PLACEHOLDER": "Vui lòng nhập lại mật khẩu \bmới"
      }
    }
  },
  "SIDEBAR_ITEMS": {
    "CHANGE_AVAILABILITY_STATUS": "Đổi",
    "CHANGE_ACCOUNTS": "Switch account",
    "SWITCH_ACCOUNT": "Switch account",
    "CONTACT_SUPPORT": "Contact support",
    "REPORT_BUG": "Báo lỗi",
    "SELECTOR_SUBTITLE": "Chọn một tài khoản từ danh sách sau",
    "PROFILE_SETTINGS": "Profile settings",
    "KEYBOARD_SHORTCUTS": "Phím tắt",
    "APPEARANCE": "Change appearance",
    "SUPER_ADMIN_CONSOLE": "SuperAdmin console",
    "DOCS": "Read documentation",
    "LOGOUT": "Log out"
  },
  "BUG_REPORT": {
    "TITLE": "Báo lỗi",
    "DESCRIPTION_LABEL": "Mô tả sự cố",
    "DESCRIPTION_PLACEHOLDER": "Mô tả sự cố mà bạn đã gặp phải...",
    "SUBMIT": "Gửi báo cáo",
    "SUBMITTING": "Đang gửi...",
    "CANCEL": "Huỷ",
    "SUCCESS": "Đã gửi báo cáo lỗi thành công. Cảm ơn bạn!",
    "VALIDATION_ERROR": "Vui lòng mô tả sự cố trước khi gửi"
  },
  "APP_GLOBAL": {
    "TRIAL_MESSAGE": "ngày dùng thử còn lại.",
    "TRAIL_BUTTON": "Mua Ngay",
    "DELETED_USER": "Người dùng bị xoá",
    "EMAIL_VERIFICATION_PENDING": "It seems that you haven't verified your email address yet. Please check your inbox for the verification email.",
    "RESEND_VERIFICATION_MAIL": "Resend verification email",
    "EMAIL_VERIFICATION_SENT": "Verification email has been sent. Please check your inbox.",
    "ACCOUNT_SUSPENDED": {
      "TITLE": "Tài khoản bị ngưng",
      "MESSAGE": "Tài khoản của bạn bị tạm ngưng. Vui lòng liên hệ với nhóm hỗ trợ để biết thêm thông tin."
    }
  },
  "COMPONENTS": {
    "CODE": {
      "BUTTON_TEXT": "Sao Chép",
      "CODEPEN": "Open in CodePen",
      "COPY_SUCCESSFUL": "Copied to clipboard"
    },
    "SHOW_MORE_BLOCK": {
      "SHOW_MORE": "Xem thêm",
      "SHOW_LESS": "Xem ít"
    },
    "FILE_BUBBLE": {
      "DOWNLOAD": "Tải xuống",
      "UPLOADING": "Đang tải lên...",
      "INSTAGRAM_STORY_UNAVAILABLE": "Hội thoại này không còn nữa.",
      "RECORDING_UNAVAILABLE": "Bản ghi âm này không còn khả dụng.",
      "DELETE_RECORDING": {
        "BUTTON": "Xóa bản ghi cuộc gọi",
        "TITLE": "Xóa bản ghi cuộc gọi?",
        "DESCRIPTION": "Tất cả bản ghi của cuộc gọi này sẽ bị xóa vĩnh viễn khỏi tổng đài điện thoại và không thể khôi phục. Bản chép lời và bản tóm tắt cuộc gọi vẫn được giữ lại.",
        "CONFIRM": "Xóa",
        "SUCCESS": "Đã xóa bản ghi cuộc gọi",
        "ERROR": "Không thể xóa bản ghi cuộc gọi. Vui lòng thử lại."
      }
    },
    "LOCATION_BUBBLE": {
      "SEE_ON_MAP": "Xem trên bản đồ"
    },
    "FORM_BUBBLE": {
      "SUBMIT": "Gửi"
    },
    "MEDIA": {
      "IMAGE_UNAVAILABLE": "This image is no longer available.",
      "LOADING_FAILED": "Loading failed"
    }
  },
  "CONFIRM_EMAIL": "Đang xác thực...",
  "SETTINGS": {
    "INBOXES": {
      "NEW_INBOX": "Thêm Hộp thư đến"
    }
  },
  "SIDEBAR": {
    "NO_ITEMS": "No items",
    "CURRENTLY_VIEWING_ACCOUNT": "Hiện đang xem:",
    "SWITCH": "Chuyển",
    "INBOX_VIEW": "Inbox View",
    "CONVERSATIONS": "Cuộc trò chuyện",
    "INBOX": "My Inbox",
    "ALL_CONVERSATIONS": "Tất cả cuộc trò chuyện",
    "MENTIONED_CONVERSATIONS": "Nhắn đến",
    "PARTICIPATING_CONVERSATIONS": "Participating",
    "UNATTENDED_CONVERSATIONS": "Không giám sát",
    "REPORTS": "Báo cáo",
    "SETTINGS": "Cài Đặt",
    "CONTACTS": "Liên hệ",
    "DATA_ASSISTANT": "Trợ lý dữ liệu",
    "CAPTAIN": "Captain",
    "CAPTAIN_ASSISTANTS": "Assistants",
    "CAPTAIN_DOCUMENTS": "Documents",
    "CAPTAIN_RESPONSES": "FAQs",
    "HOME": "Trang Chủ",
    "AGENTS": "Đại lý",
    "AGENT_BOTS": "Bots",
    "AUDIT_LOGS": "Audit Logs",
    "WHATSAPP_TEMPLATES": "Mẫu WhatsApp",
    "BLOCKED_DOMAINS": "SPAM",
    "INBOXES": "Hộp thư đến",
    "NOTIFICATIONS": "Thông báo",
    "CANNED_RESPONSES": "Thư mẫu phẩn hồi",
    "INTEGRATIONS": "Tích hợp",
    "PROFILE_SETTINGS": "Cài Đặt Hồ Sơ",
    "ACCOUNT_SETTINGS": "Cài Đặt Tài Khoản",
    "APPLICATIONS": "Ứng dụng",
    "LABELS": "Nhãn",
    "CUSTOM_ATTRIBUTES": "Thuộc tính tùy chỉnh",
    "AUTOMATION": "Tự động hoá",
    "MACROS": "Macros",
    "TEAMS": "Nhóm",
    "BILLING": "Phí",
    "CUSTOM_VIEWS_FOLDER": "Thư mục",
    "CUSTOM_VIEWS_SEGMENTS": "Phân khúc",
    "ALL_CONTACTS": "Tất cả liên lạc",
    "TAGGED_WITH": "Được gắn thẻ với",
    "NEW_LABEL": "Nhãn mới",
    "NEW_TEAM": "Nhóm mới",
    "NEW_INBOX": "Kênh mới",
    "REPORTS_CONVERSATION": "Các cuộc hội thoại",
    "CSAT": "CSAT",
    "LIVE_CHAT": "Live Chat",
    "SMS": "SMS",
    "CAMPAIGNS": "Chiến dịch",
    "ONGOING": "Đang diễn ra",
    "ONE_OFF": "Một lần",
    "REPORTS_SLA": "SLA",
    "REPORTS_BOT": "Bot",
    "REPORTS_AGENT": "Nhà cung cấp",
    "REPORTS_LABEL": "Nhãn",
    "REPORTS_INBOX": "Kênh",
    "REPORTS_TEAM": "Nhóm",
    "REPORTS_PHONE": "Điện thoại",
    "WALLBOARD": "Wallboard",
    "WALLBOARD_OVERVIEW": "Tổng quan",
    "WALLBOARD_QUEUES": "Hàng đợi",
    "DATA_ASSISTANT_CHAT": "Chat",
    "DATA_ASSISTANT_REPORTS": "Báo cáo",
    "NO_WAITING_CALLERS": "không có người gọi đang chờ",
    "WAITING_CALLERS": "{count} người gọi đang chờ",
    "SET_AVAILABILITY_TITLE": "Đặt chính mình như",
    "SET_YOUR_AVAILABILITY": "Đặt tính khả dụng của bạn",
    "AVAILABILITY_IMPERSONATING": "Bị khóa khi đang đăng nhập với tư cách người dùng này",
    "SLA": "SLA",
    "CUSTOM_ROLES": "Custom Roles",
    "NEW_CONVERSATION": "Cuộc trò chuyện mới",
    "DRAFT": "Bản nháp",
    "BETA": "Beta",
    "REPORTS_OVERVIEW": "Tổng quan",
    "REAUTHORIZE": "Your inbox connection has expired, please reconnect\n to continue receiving and sending messages",
    "HELP_CENTER": {
      "TITLE": "Help Center",
      "ARTICLES": "Articles",
      "CATEGORIES": "Danh mục",
      "LOCALES": "Ngôn ngữ",
      "SETTINGS": "Cài đặt",
      "DICTIONARY": "Từ điển"
    },
    "CHANNELS": "Kênh",
    "SET_AUTO_OFFLINE": {
      "TEXT": "Tự động đánh dấu ngoại tuyến",
      "INFO_TEXT": "Hãy để hệ thống tự động đánh dấu bạn ngoại tuyến khi bạn không sử dụng ứng dụng hoặc trang tổng quan.",
      "INFO_SHORT": "Automatically mark offline when you aren't using the app."
    },
    "DOCS": "Đọc tài liệu"
  },
  "BLOCKED_DOMAINS_SETTINGS": {
    "HEADER": "Tên miền và liên hệ bị chặn",
    "DESCRIPTION": "Danh sách tên miền email bị chặn cho tài khoản này.",
    "NO_BLOCKED_DOMAINS": "Không tìm thấy tên miền bị chặn nào.",
    "BLOCKED_CONTACTS_BTN": "Liên hệ bị chặn"
  },
  "BILLING_SETTINGS": {
    "TITLE": "Phí",
    "DESCRIPTION": "Manage your subscription here, upgrade your plan and get more for your team.",
    "CURRENT_PLAN": {
      "TITLE": "Gói hiện tại",
      "PLAN_NOTE": "Bạn hiện đã đăng ký gói **{plan}** với **{quantity}** giấy phép",
      "SEAT_COUNT": "Number of seats",
      "RENEWS_ON": "Renews on"
    },
    "VIEW_PRICING": "View Pricing",
    "MANAGE_SUBSCRIPTION": {
      "TITLE": "Quản lý thuê bao của bạn",
      "DESCRIPTION": "Xem các hóa đơn trước đây của bạn, chỉnh sửa chi tiết thanh toán hoặc hủy thuê bao của bạn.",
      "BUTTON_TXT": "Đi tới cổng thanh toán"
    },
    "CAPTAIN": {
      "TITLE": "Captain",
      "DESCRIPTION": "Manage usage and credits for Captain AI.",
      "BUTTON_TXT": "Buy more credits",
      "DOCUMENTS": "Documents",
      "RESPONSES": "Responses",
      "UPGRADE": "Captain is not available on the free plan, upgrade now to get access to assistants, copilot and more."
    },
    "CHAT_WITH_US": {
      "TITLE": "Cần hỗ trợ?",
      "DESCRIPTION": "Bạn có gặp phải bất kỳ vấn đề nào trong thanh toán không? Hãy cho chúng tôi biết.",
      "BUTTON_TXT": "Trò chuyện với chúng tôi"
    },
    "NO_BILLING_USER": "Tài khoản thanh toán của bạn đang được định cấu hình. Hãy làm mới trang và thử lại."
  },
  "CREATE_ACCOUNT": {
    "NO_ACCOUNT_WARNING": "Ồ ồ! Chúng tôi không thể tìm thấy bất kỳ tài khoản nào. Vui lòng tạo một tài khoản mới để tiếp tục.",
    "NEW_ACCOUNT": "Tạo mới tài khoản",
    "SELECTOR_SUBTITLE": "Tạo mới một tài khoản",
    "API": {
      "SUCCESS_MESSAGE": "Tài khoản được tạo thành công",
      "EXIST_MESSAGE": "Tài khoản đã tồn tại",
      "ERROR_MESSAGE": "Không thể kết nối với Máy chủ Woot, Vui lòng thử lại sau"
    },
    "FORM": {
      "NAME": {
        "LABEL": "Tên công ty",
        "PLACEHOLDER": "Wayne Enterprises"
      },
      "SUBMIT": "Gửi",
      "CANCEL": "Huỷ"
    }
  },
  "KEYBOARD_SHORTCUTS": {
    "TOGGLE_MODAL": "Xem tất cả phím tắt",
    "TITLE": {
      "OPEN_CONVERSATION": "Mở cuộc trò chuyện",
      "RESOLVE_AND_NEXT": "Giải quyết và đi đến cái tiếp theo",
      "NAVIGATE_DROPDOWN": "Điều hướng các mục thả xuống",
      "RESOLVE_CONVERSATION": "Giải quyết cuộc trò chuyện",
      "GO_TO_CONVERSATION_DASHBOARD": "Đi tới Trang tổng quan cuộc trò chuyện",
      "ADD_ATTACHMENT": "Thêm đính kèm",
      "GO_TO_CONTACTS_DASHBOARD": "Đi tới Trang tổng quan liên hệ",
      "TOGGLE_SIDEBAR": "Chuyển đổi thanh bên",
      "GO_TO_REPORTS_SIDEBAR": "Đi đến thanh bên Báo cáo",
      "MOVE_TO_NEXT_TAB": "Di chuyển đến tab tiếp theo trong danh sách cuộc trò chuyện",
      "GO_TO_SETTINGS": "Đi đến Cài đặt",
      "SWITCH_TO_PRIVATE_NOTE": "Chuyển sang Ghi chú Riêng tư",
      "SWITCH_TO_REPLY": "Chuyển sang phản hồi",
      "TOGGLE_SNOOZE_DROPDOWN": "Chuyển đổi thả xuống tạm dừng",
      "AI_ASSIST_MENU": "Trợ lý AI",
      "AI_ASSIST_GRAMMAR": "Sửa ngữ pháp",
      "AI_ASSIST_UNIFY_LANG": "Thống nhất ngôn ngữ tin nhắn"
    }
  }
}
